import styled from 'styled-components/macro'
import { ifProp } from 'styled-tools'

const CheckboxInput = styled.input.attrs({
  type: 'checkbox'
})`
  position: absolute;
  top: 0;
  left: 0;
  margin: 0;
  padding: 0;
  width: 100%;
  height: 100%;
  z-index: 2;
  opacity: 0;
  cursor: ${ifProp('disabled', 'not-allowed', 'pointer')};
`

export default CheckboxInput
